function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEventListener } from '../_hooks/EventListener';
function noop() {}
var availableTriggers = ['click', 'hover', 'none', 'contextmenu', 'focus', 'always'];
export function triggerListeners(_ref) {
  var value = _ref.value,
    off = _ref.off,
    on = _ref.on,
    trigger = _ref.trigger,
    scope = _ref.scope;
  var targetTriggers = Array.isArray(trigger) ? trigger : [trigger];
  var handlerOrNoop = function handlerOrNoop(fn, trigger) {
    var isTargetTrigger = targetTriggers.includes(trigger);
    return {
      handler: isTargetTrigger ? fn : noop,
      noopHandler: !isTargetTrigger
    };
  };
  availableTriggers.forEach(function (trigger) {
    switch (trigger) {
      case 'click':
        var handler = handlerOrNoop(value ? off : on, trigger);
        useEventListener(_objectSpread({
          dependencies: [handler],
          event: 'click',
          scope: scope
        }, handler));
        break;
      case 'contextmenu':
        var ctxMenuHandler = handlerOrNoop(value ? off : on, trigger);
        useEventListener(_objectSpread({
          dependencies: [ctxMenuHandler],
          event: 'contextmenu',
          scope: scope
        }, ctxMenuHandler));
        break;
      case 'hover':
        var mouseLeaveHandler = handlerOrNoop(off, trigger);
        useEventListener(_objectSpread({
          event: 'mouseleave',
          scope: scope
        }, mouseLeaveHandler));
        var mouseEnterHandler = handlerOrNoop(on, trigger);
        useEventListener(_objectSpread({
          event: 'mouseenter',
          scope: scope
        }, mouseEnterHandler));
        break;
      case 'focus':
        var blurHandler = handlerOrNoop(off, trigger);
        useEventListener(_objectSpread({
          event: 'blur',
          scope: scope
        }, blurHandler));
        var focusHandler = handlerOrNoop(on, trigger);
        useEventListener(_objectSpread({
          event: 'focus',
          scope: scope
        }, focusHandler));
        break;
    }
  });
}
//# sourceMappingURL=triggerListeners.js.map